import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=2b1ffd95&scoped=true"
import script from "./NodeConfig.vue?vue&type=script&lang=js"
export * from "./NodeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ffd95",
  null
  
)

export default component.exports